(function () {
  'use strict';

  function boot(root) {
    if (!root || root.dataset.originalsReadingPlaceMounted === 'true') return;
    var configNode = root.querySelector('[data-originals-config]');
    var config;
    try { config = JSON.parse(configNode && configNode.textContent || '{}'); } catch (error) { config = {}; }
    var scope = config.signedIn === true
      ? (/^[a-f0-9]{64}$/.test(String(config.userScope || '')) ? config.userScope : null)
      : 'device-guest';
    var requestScope = /^[a-f0-9]{64}$/.test(String(config.requestScope || '')) ? config.requestScope : null;
    var accountSync = config.signedIn === true && !!scope && !!requestScope;
    var panel = root.querySelector('[data-originals-text-mode-panel="read"]');
    var resume = root.querySelector('[data-originals-continue-reading]');
    var status = root.querySelector('[data-originals-reading-place-status]');
    var retry = root.querySelector('[data-originals-reading-place-retry]');
    var useDevice = root.querySelector('[data-originals-reading-place-device]');
    var useAccount = root.querySelector('[data-originals-reading-place-account]');
    if (!panel || !resume || !status || !retry || !useDevice || !useAccount) return;
    root.dataset.originalsReadingPlaceMounted = 'true';
    var chapterId = null;
    var revision = null;
    var paragraphs = [];
    var localPlace = null;
    var accountPlace = null;
    var serverVersion = null;
    var state = 'none';
    var generation = 0;
    var saving = false;
    var scrollTimer = null;
    var accountChanged = false;

    function key() { return scope && chapterId && revision ? ['dsd-originals', 'reading-place-v1', scope, chapterId, revision].join(':') : null; }
    function validAnchor(value) { return typeof value === 'string' && paragraphs.some(function (node) { return node.dataset.originalsProseAnchor === value; }); }
    function readLocal() {
      if (accountChanged) return null;
      var name = key();
      if (!name) return null;
      try {
        var value = JSON.parse(localStorage.getItem(name) || 'null');
        return value && value.chapterId === chapterId && value.proseRevision === revision && validAnchor(value.anchor) &&
          typeof value.pending === 'boolean' && (value.baseVersion === null || Number.isSafeInteger(value.baseVersion) && value.baseVersion >= 0) ? value : null;
      } catch (error) { return null; }
    }
    function writeLocal(value) {
      var name = key();
      if (!name) return false;
      try { localStorage.setItem(name, JSON.stringify(value)); return true; } catch (error) { return false; }
    }
    function place() { return accountChanged ? null : localPlace && validAnchor(localPlace.anchor) ? localPlace.anchor : accountPlace; }
    function render() {
      resume.hidden = !place();
      retry.hidden = !accountSync || accountChanged || !['unsynced', 'conflict', 'accessDenied'].includes(state);
      useDevice.hidden = !accountSync || accountChanged || state !== 'conflict' || !localPlace || !localPlace.pending || serverVersion === null;
      useAccount.hidden = !accountSync || accountChanged || state !== 'conflict' || !accountPlace;
      status.textContent = status.dataset[accountChanged ? 'accountChanged' : state] || '';
    }
    function changed() {
      if (typeof CustomEvent === 'function' && typeof root.dispatchEvent === 'function') {
        root.dispatchEvent(new CustomEvent('dsd:originals-readingchange'));
      }
    }
    function invalidateAccount() {
      accountChanged = true;
      generation += 1;
      if (scrollTimer !== null) { clearTimeout(scrollTimer); scrollTimer = null; }
      localPlace = null;
      accountPlace = null;
      serverVersion = null;
      state = 'accountChanged';
      render();
      changed();
    }
    function request(method, payload) {
      return fetch('/apps/dsd-firebase-custom-token/originals-polish/reading-progress', {
        method: method, credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, payload, { readerScope: requestScope }))
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) { var error = new Error(body.error || 'reading_progress_unavailable');
            error.code = body.error; error.status = response.status; throw error; }
          return body;
        });
      });
    }
    function sync() {
      if (!accountSync || accountChanged || saving || !localPlace || !localPlace.pending || serverVersion === null) return;
      if (localPlace.baseVersion !== serverVersion) { state = 'conflict'; render(); return; }
      var target = localPlace.anchor;
      var activeChapter = chapterId;
      var activeRevision = revision;
      var activeGeneration = generation;
      var didSave = false;
      saving = true;
      state = 'loading'; render();
      request('PUT', { chapterId: activeChapter, proseRevision: activeRevision, anchor: target,
        expectedVersion: serverVersion }).then(function (body) {
        if (activeGeneration !== generation || accountChanged || !body.item || body.item.chapterId !== activeChapter ||
            body.item.proseRevision !== activeRevision || body.item.anchor !== target ||
            !Number.isSafeInteger(body.item.version) || body.item.version !== serverVersion + 1) throw new Error('reading_progress_response_invalid');
        serverVersion = body.item.version;
        didSave = true;
        accountPlace = target;
        if (localPlace && localPlace.anchor === target) localPlace.pending = false;
        else if (localPlace) localPlace.baseVersion = serverVersion;
        if (localPlace && !writeLocal(localPlace)) { state = 'storageUnavailable'; return; }
        state = localPlace && localPlace.pending ? 'unsynced' : 'synced';
      }).catch(function (error) {
        if (activeGeneration !== generation || accountChanged) return;
        if (error.code === 'reading_progress_conflict') { load(); return; }
        if (error.code === 'reading_content_changed') { state = 'contentChanged'; return; }
        if (error.code === 'reading_content_access_denied') { state = 'accessDenied'; return; }
        if (error.status === 401 || error.code === 'account_changed_reload') {
          invalidateAccount(); return;
        }
        state = 'unsynced';
      }).finally(function () {
        saving = false;
        if (activeGeneration !== generation || accountChanged) return;
        render(); changed();
        if (didSave && localPlace && localPlace.pending && state === 'unsynced' && localPlace.baseVersion === serverVersion) {
          scrollTimer = setTimeout(function () { scrollTimer = null; sync(); }, 2500);
        }
      });
    }
    function load() {
      if (!accountSync || accountChanged || !chapterId) return;
      var activeGeneration = ++generation;
      var activeChapter = chapterId;
      state = 'loading'; render();
      request('POST', { chapterIds: [activeChapter] }).then(function (body) {
        if (activeGeneration !== generation || accountChanged) return;
        var row = body && body.version === 1 && Array.isArray(body.rows) && body.rows.length === 1 ? body.rows[0] : null;
        if (!row || row.chapterId !== activeChapter || !Number.isSafeInteger(row.version) || row.version < 0 ||
            !['not_started', 'in_progress'].includes(row.progress) || row.progress === 'in_progress' &&
            (row.proseRevision !== revision || !validAnchor(row.anchor))) throw new Error('reading_progress_response_invalid');
        serverVersion = row.version;
        accountPlace = row.progress === 'in_progress' ? row.anchor : null;
        if (localPlace && localPlace.pending) {
          if (localPlace.baseVersion === null && serverVersion === 0) {
            localPlace.baseVersion = 0;
            if (!writeLocal(localPlace)) { state = 'storageUnavailable'; render(); return; }
          }
          state = localPlace.baseVersion === serverVersion ? 'unsynced' : 'conflict';
          if (state === 'unsynced') sync();
        } else {
          if (accountPlace) {
            localPlace = { chapterId: activeChapter, proseRevision: revision, anchor: accountPlace,
              pending: false, baseVersion: serverVersion, updatedAt: row.updatedAt };
            writeLocal(localPlace);
          }
          state = row.contentChanged === true && !localPlace ? 'contentChanged' : 'synced';
        }
        render(); changed();
      }).catch(function (error) {
        if (activeGeneration !== generation || accountChanged) return;
        if (error.status === 401 || error.code === 'account_changed_reload') {
          invalidateAccount(); return;
        }
        state = 'unsynced'; render();
      });
    }
    function capture() {
      if (!scope || accountChanged || !chapterId || !revision || panel.hidden || !paragraphs.length) return;
      var focus = Number(window.innerHeight || 720) * 0.42;
      var visible = paragraphs.filter(function (node) {
        var rect = node.getBoundingClientRect(); return rect.bottom > 0 && rect.top < window.innerHeight;
      });
      if (!visible.length) return;
      var nearest = visible.reduce(function (best, node) {
        return Math.abs(node.getBoundingClientRect().top - focus) < Math.abs(best.getBoundingClientRect().top - focus) ? node : best;
      });
      var anchor = nearest.dataset.originalsProseAnchor;
      if (!validAnchor(anchor) || localPlace && localPlace.anchor === anchor) return;
      var baseVersion = localPlace && localPlace.pending ? localPlace.baseVersion : serverVersion;
      var next = { chapterId: chapterId, proseRevision: revision, anchor: anchor,
        pending: accountSync, baseVersion: baseVersion, updatedAt: new Date().toISOString() };
      if (!writeLocal(next)) { state = 'storageUnavailable'; render(); return; }
      localPlace = next;
      state = accountSync ? 'unsynced' : 'local';
      render(); changed();
      if (accountSync) sync();
    }
    function resumeAt(anchor) {
      if (accountChanged || !validAnchor(anchor)) return;
      var readButton = root.querySelector('[data-originals-text-mode-button="read"]');
      if (readButton && panel.hidden) readButton.click();
      var target = paragraphs.find(function (node) { return node.dataset.originalsProseAnchor === anchor; });
      if (target) target.scrollIntoView({ block: 'center', behavior: root.dataset.readerMotion === 'reduced' ? 'auto' : 'smooth' });
    }

    root.addEventListener('dsd:originals-proseready', function (event) {
      generation += 1;
      if (scrollTimer !== null) { clearTimeout(scrollTimer); scrollTimer = null; }
      if (accountChanged) { render(); return; }
      chapterId = event.detail && event.detail.chapterId;
      revision = String(root.dataset.originalsProseRevision || '');
      paragraphs = Array.from(root.querySelectorAll('[data-originals-read] [data-originals-prose-anchor]'));
      localPlace = readLocal(); accountPlace = null; serverVersion = null;
      state = scope ? 'local' : 'storageUnavailable';
      render(); changed();
      if (accountSync) load();
    });
    window.addEventListener('scroll', function () {
      if (scrollTimer !== null) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { scrollTimer = null; capture(); }, 1500);
    }, { passive: true });
    window.addEventListener('pagehide', capture);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') capture(); });
    resume.addEventListener('click', function () { resumeAt(place()); });
    retry.addEventListener('click', load);
    useDevice.addEventListener('click', function () {
      if (accountChanged || !localPlace || !localPlace.pending || serverVersion === null) return;
      localPlace.baseVersion = serverVersion;
      if (!writeLocal(localPlace)) { state = 'storageUnavailable'; render(); return; }
      sync();
    });
    useAccount.addEventListener('click', function () {
      if (accountChanged || !accountPlace || serverVersion === null) return;
      localPlace = { chapterId: chapterId, proseRevision: revision, anchor: accountPlace,
        pending: false, baseVersion: serverVersion, updatedAt: new Date().toISOString() };
      if (!writeLocal(localPlace)) { state = 'storageUnavailable'; render(); return; }
      state = 'synced'; render(); changed(); resumeAt(accountPlace);
    });
    ['dsd:shopify-account:changed', 'dsd:shopify-logout'].forEach(function (name) {
      window.addEventListener(name, invalidateAccount);
    });
    render();
  }

  document.querySelectorAll('[data-dsd-originals-library]').forEach(boot);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-dsd-originals-library]').forEach(boot);
  });
})();
